export const PageBody = ({ children, widthClass = "max-w-screen-lg" }) => (
    <div className={`${widthClass} mx-auto`}>
        {children}
    </div>
);
